
import { ToolbarConfig } from '@/types'
import { viewButton } from '@/utils/toolbar-config'
import { defineComponent, onMounted, PropType, reactive } from 'vue'

import {
  FileIcon,
  BarraIcon,
  BarraSimpleIcon,
  FullIScreenIcon,
  PrintIcon,
  AbsibIcon,
  AgeticIcon,
  FileSimpleIcon,
  AbsibSimpleIcon,
  AgeticSimpleIcon,
  BookmarkIcon,
  DownIcon,
  DownloadIcon,
  ZoomInIcon,
  ZoomOutIcon,
  UpIcon,
  SearchIcon
} from './icons'
import { onPrint } from '../utils/printer'
import LoaderComponent from './load/loaderComponent.vue'

export default defineComponent({
  name: 'Toolbar',
  props: {
    showElem: { type: Function },
    onOpenSidebar: { type: Function },
    slotProps: {},
    pageScale: {},
    viewSidebar: {
      default: () => {
        return { files: false }
      }
    },
    pdfApp: { type: Object as PropType<any> },
    viewButton: {
      default: () => viewButton,
      type: Object as PropType<ToolbarConfig>
    },
    viewSignature: {
      default: () => viewButton,
      type: Object as PropType<ToolbarConfig>
    },
    valorLegal: {
      default: () => viewButton,
      type: Object as PropType<ToolbarConfig>
    }
  },
  setup (props) {
    const visible = reactive({
      print: false,
      toolbarViewerMiddle: true,
      toolbarViewerMiddleZoom: true,
      toolbarViewerLeft: true,
      toolbarViewerRight: true
    })

    const onWatchWidth = (width) => {
      if (!document.getElementById('toolbarContainer')) return
      const toolbarWidth =
        document.getElementById('toolbarContainer').clientWidth
      if (toolbarWidth > 650 && toolbarWidth < 800) {
        visible.toolbarViewerMiddle = true
        visible.toolbarViewerMiddleZoom = false
        visible.toolbarViewerLeft = true
        visible.toolbarViewerRight = true
      } else if (toolbarWidth > 500 && toolbarWidth < 650) {
        visible.toolbarViewerMiddleZoom = true
        visible.toolbarViewerMiddle = false
        visible.toolbarViewerLeft = true
        visible.toolbarViewerRight = true
      } else if (toolbarWidth > 300 && toolbarWidth < 500) {
        visible.toolbarViewerMiddleZoom = true
        visible.toolbarViewerMiddle = false
        visible.toolbarViewerLeft = false
        visible.toolbarViewerRight = true
      } else if (toolbarWidth < 300) {
        visible.toolbarViewerMiddleZoom = true
        visible.toolbarViewerMiddle = false
        visible.toolbarViewerLeft = false
        visible.toolbarViewerRight = false
      } else {
        visible.toolbarViewerMiddleZoom = true
        visible.toolbarViewerMiddle = true
        visible.toolbarViewerLeft = true
        visible.toolbarViewerRight = true
      }
    }

    onMounted(() => {
      onWatchWidth(document.documentElement.clientWidth)
      window.addEventListener('resize', (e: any) => {
        onWatchWidth(e.target.innerWidth)
      })
    })
    return {
      visible,
      getScale (value: number): string {
        return `{ "scale": ${value} }`
      },
      onPrint: async () => {
        visible.print = true
        await onPrint('viewer', props.pdfApp)
        visible.print = false
      }
    }
  },
  components: {
    LoaderComponent,
    FileIcon,
    BarraIcon,
    BarraSimpleIcon,
    FullIScreenIcon,
    PrintIcon,
    AbsibIcon,
    AgeticIcon,
    BookmarkIcon,
    DownIcon,
    DownloadIcon,
    ZoomInIcon,
    ZoomOutIcon,
    UpIcon,
    SearchIcon,
    FileSimpleIcon,
    AbsibSimpleIcon,
    AgeticSimpleIcon
  }
})
